var _WebMapTileServiceCapabilities;
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import i18next from "i18next";
import { createTransformer } from "mobx-utils";
import defined from "terriajs-cesium/Source/Core/defined";
import loadXML from "../../../Core/loadXML";
import { networkRequestError } from "../../../Core/TerriaError";
import xml2json from "../../../ThirdParty/xml2json";

/* For some reason LegendUrls are formatted differently from WMS - this makes me very upset >:(
  WMTS Example:
    <LegendURL format="image/png"
    xlink:href="http://www.maps.bob/etopo2/legend.png" />

  WMS Example:
  <LegendURL width="184" height="220">
    <Format>image/png</Format>
    <OnlineResource xmlns:xlink="http://www.w3.org/1999/xlink" xlink:type="simple" xlink:href="http://www.maps.bob/etopo2/legend.png"/>
  </LegendURL>
*/

export default class WebMapTileServiceCapabilities {
  constructor(json) {
    var _this$json$Contents, _this$json$Contents2;
    this.json = json;
    _defineProperty(this, "layers", void 0);
    _defineProperty(this, "tileMatrixSets", void 0);
    this.layers = this.parseLayers((_this$json$Contents = this.json.Contents) === null || _this$json$Contents === void 0 ? void 0 : _this$json$Contents.Layer);
    this.tileMatrixSets = this.parseTileMatrixSets((_this$json$Contents2 = this.json.Contents) === null || _this$json$Contents2 === void 0 ? void 0 : _this$json$Contents2.TileMatrixSet);
  }
  get ServiceIdentification() {
    return this.json.ServiceIdentification;
  }
  get OperationsMetadata() {
    const operationsMetadata = this.json.OperationsMetadata;
    if (!operationsMetadata) {
      return undefined;
    }
    const operation = Array.isArray(operationsMetadata.Operation) ? operationsMetadata.Operation : [operationsMetadata.Operation];
    return operation.reduce((acc, operation) => {
      if (!acc[operation.name]) {
        acc[operation.name] = {
          Get: Array.isArray(operation.DCP.HTTP.Get) ? operation.DCP.HTTP.Get : [operation.DCP.HTTP.Get]
        };
      }
      return acc;
    }, {});
  }
  get ServiceProvider() {
    return this.json.ServiceProvider;
  }

  /**
   * Finds the layer in GetCapabilities corresponding to a given layer name. Names are
   * resolved as foll
   *    * The layer has the title exact with the name specified.
   *    * The layer name matches the name in the spec if the namespace portion is removed.
   *
   * @param {String} name The layer name to resolve.
   * @returns {LayerType} The resolved layer, or `undefined` if the layer name could not be resolved.
   */
  findLayer(name) {
    // Look for an exact match on the name.
    if (this.layers === undefined) {
      return undefined;
    }
    let match = this.layers.find(layer => layer.Identifier === name || layer.Title === name);
    if (!match) {
      const colonIndex = name.indexOf(":");
      if (colonIndex >= 0) {
        // This looks like a namespaced name. Such names will (usually?) show up in GetCapabilities
        // as just their name without the namespace qualifier.
        const nameWithoutNamespace = name.substring(colonIndex + 1);
        match = this.layers.find(layer => layer.Identifier === nameWithoutNamespace || layer.Title === nameWithoutNamespace);
      }
    }
    return match;
  }
  findTileMatrix(set) {
    if (this.tileMatrixSets === undefined) {
      return undefined;
    }
    return this.tileMatrixSets.find(tileMatrixSet => tileMatrixSet.Identifier === set);
  }
  parseLayers(layers) {
    if (!layers) {
      return [];
    }
    return Array.isArray(layers) ? layers : [layers];
  }
  parseTileMatrixSets(tileMatrixSets) {
    if (!tileMatrixSets) {
      return [];
    }
    return Array.isArray(tileMatrixSets) ? tileMatrixSets : [tileMatrixSets];
  }
}
_WebMapTileServiceCapabilities = WebMapTileServiceCapabilities;
_defineProperty(WebMapTileServiceCapabilities, "fromUrl", createTransformer(url => {
  return Promise.resolve(loadXML(url)).then(function (capabilitiesXml) {
    const json = xml2json(capabilitiesXml);
    if (!capabilitiesXml || !defined(json.ServiceIdentification)) {
      throw networkRequestError({
        title: i18next.t("models.webMapTileServiceCatalogGroup.invalidCapabilitiesTitle"),
        message: i18next.t("models.webMapTileServiceCatalogGroup.invalidCapabilitiesMessage", {
          url: url
        })
      });
    }
    return new _WebMapTileServiceCapabilities(json);
  });
}));